<template>
    <div class="animated fadeIn" v-if="this.isUserLoaded()">
        <div class="row">
            <div class="col col-md-10 offset-md-1 col-xl-8 offset-xl-2">
                <b-card>

                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='* Фамилия'
                                    :state="validateState('surname')"
                                    :invalid-feedback="veeErrors.first('surname')"
                                    description="[surname]"
                            >
                                <b-input
                                        v-model="user.surname"
                                        v-validate="{required:true,max:100}"
                                        name="surname"
                                        data-vv-as="'Фамилия'"
                                        :state="validateState('surname')"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='* Имя'
                                    :state="validateState('name_')"
                                    :invalid-feedback="veeErrors.first('name_')"
                                    description="[name_]"
                            >
                                <b-input
                                        v-model="user.name_"
                                        v-validate="{required:true,max:100}"
                                        name="name_"
                                        data-vv-as="'Имя'"
                                        :state="validateState('name_')"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='* Отчество'
                                    :state="validateState('patro')"
                                    :invalid-feedback="veeErrors.first('patro')"
                                    description="[patro]"
                            >
                                <b-input
                                        v-model="user.patro"
                                        v-validate="{required:true,max:100}"
                                        name="patro"
                                        data-vv-as="'Отчество'"
                                        :state="validateState('patro')"
                                />
                            </b-form-group>
                        </div>
                    </div>


                    <div class="row">

                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='* Роль'
                                    description="[role_id]"
                            >
                                <select v-model="user.role_id" class="form-control">
                                    <option v-for="role_title,role_id in roles" :key="role_id" :value="role_id">{{role_title}}</option>
                                </select>
                            </b-form-group>
                        </div>

                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='* Компания'
                                    description="в которой работает пользователь [company_id]"
                            >
                                <select v-model="user.company_id" class="form-control">
                                    <!--option :key="null" :value="null">--- не выбрана ---</option-->
                                    <option v-for="company in mainCompanies" :key="company.id" :value="company.id">{{company.title}}</option>
                                </select>
                            </b-form-group>
                        </div>

                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='* % вознаграждения'
                                    :state="validateState('procent_reward')"
                                    :invalid-feedback="veeErrors.first('procent_reward')"
                                    description="[procent_reward]"
                            >
                                <b-input
                                        v-model="user.procent_reward"
                                        v-validate="{integer:true,min_value:0, max_value:100}"
                                        name="procent_reward"
                                        data-vv-as="'% вознаграждения'"
                                        :state="validateState('procent_reward')"
                                />
                            </b-form-group>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='* Логин'
                                    :state="validateState('login')"
                                    :invalid-feedback="veeErrors.first('login')"
                                    description="[login]"
                            >
                                <b-input
                                        v-model="user.login"
                                        v-validate="{required:true,max:100}"
                                        name="login"
                                        data-vv-as="'Логин'"
                                        :state="validateState('login')"
                                />
                            </b-form-group>
                        </div>

                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='* E-mail'
                                    :state="validateState('email')"
                                    :invalid-feedback="veeErrors.first('email')"
                                    description="[email]"
                            >
                                <b-input
                                        v-model="user.email"
                                        v-validate="{ required:true, email:true, max:100 }"
                                        name="email"
                                        data-vv-as="'E-mail'"
                                        :state="validateState('email')"
                                />
                            </b-form-group>
                        </div>

                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='Skype'
                                    :state="validateState('skype')"
                                    :invalid-feedback="veeErrors.first('skype')"
                                    description="[skype]"
                            >
                                <b-input
                                        v-model="user.skype"
                                        v-validate="{ max:100 }"
                                        name="skype"
                                        data-vv-as="'Skype'"
                                        :state="validateState('skype')"
                                />
                            </b-form-group>
                        </div>

                    </div>

                    <div class="row">

                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='Телефон (мобильный)'
                                    :state="validateState('phone_mobi')"
                                    :invalid-feedback="veeErrors.first('phone_mobi')"
                                    description="[phone_mobi]"
                            >
                                <b-input
                                        v-model="user.phone_mobi"
                                        v-validate="{ mobile:true }"
                                        name="phone_mobi"
                                        data-vv-as="'Телефон (мобильный)'"
                                        :state="validateState('phone_mobi')"
                                />
                            </b-form-group>
                        </div>

                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='Телефон (офисный)'
                                    :state="validateState('phone_stat')"
                                    :invalid-feedback="veeErrors.first('phone_stat')"
                                    description="[phone_stat]"
                            >
                                <b-input
                                        v-model="user.phone_stat"
                                        v-validate="{ phone:true }"
                                        name="phone_stat"
                                        data-vv-as="'Телефон (офисный)'"
                                        :state="validateState('phone_stat')"
                                />
                            </b-form-group>
                        </div>

                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='Asterisk'
                                    :state="validateState('local_phone_stat')"
                                    :invalid-feedback="veeErrors.first('local_phone_stat')"
                                    description="[local_phone_stat]"
                            >
                                <b-input
                                        v-model="user.local_phone_stat"
                                        v-validate="{ regex:/^[0-9]+$/, min:3, max:3 }"
                                        name="local_phone_stat"
                                        data-vv-as="'Asterisk'"
                                        :state="validateState('local_phone_stat')"
                                />
                            </b-form-group>
                        </div>

                    </div>

                    <div class="row">

                        <div class="col-12 col-lg-4">
                            <b-form-group
                                    label='Новый пароль'
                                    :state="validateState('password')"
                                    :invalid-feedback="veeErrors.first('password')"
                                    description="[password]"
                            >
                                <b-input
                                        v-model="user.password"
                                        v-validate="{ min:5, max:30 }"
                                        name="password"
                                        data-vv-as="'Новый пароль'"
                                        :state="validateState('password')"
                                />
                            </b-form-group>
                        </div>


                        <div class="col-12 col-lg-5">
                            <b-form-group label='Токен' >
                                <b-input v-model="token" readonly />
                            </b-form-group>
                        </div>

                        <div class="col-12 col-lg-3">
                            <b-form-group  label='Получение токена' >
                                <b-button type="button" variant="primary"  @click='getToken(user.id)'><i class="fa fa-add"></i> Получить токен</b-button>
                            </b-form-group>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-6">

                            <b-form-group label='Пометки пользователя' description="[text_user]">
                                <b-input v-model="user.text_user" readonly />
                            </b-form-group>

                            <b-form-group
                                    label='Пометки администратора'
                                    :state="validateState('text_admin')"
                                    :invalid-feedback="veeErrors.first('text_admin')"
                                    description="[text_admin]"
                            >
                                <b-input
                                        v-model="user.text_admin"
                                        v-validate="{ max:20000 }"
                                        name="text_admin"
                                        data-vv-as="'Пометки администратора'"
                                        :state="validateState('text_admin')"
                                />
                            </b-form-group>


                            <b-form-group
                                    label='Скрытые пометки администратора'
                                    :state="validateState('text_admin_hidden')"
                                    :invalid-feedback="veeErrors.first('text_admin_hidden')"
                                    description="[text_admin_hidden]"
                            >
                                <b-input
                                        v-model="user.text_admin_hidden"
                                        v-validate="{ max:20000 }"
                                        name="text_admin_hidden"
                                        data-vv-as="'Скрытые пометки администратора'"
                                        :state="validateState('text_admin_hidden')"
                                />
                            </b-form-group>

                        </div>

                        <div class="col-12 col-lg-6">

                            <h4>Фотография</h4>

                            <div class="row">
                                <div class="col col-lg-6">
                                    <b-form-group
                                        description='Подготовьте и загрузите фотографию с соотношением сторон 1:1 (квадрат) размерами примерно 200x200. Допустимы файлы форматов: jpeg, png, gif. [avatar_file]'
                                    >
                                        <b-form-file id="file-default" v-model='images.image_file'
                                                     accept="image/jpeg, image/png, image/gif"
                                                     placeholder="Выберите файл..."
                                                     drop-placeholder="Кидать файло сюды..."
                                        ></b-form-file>
                                    </b-form-group>
                                </div>
                                <div class="col col-lg-6" v-if="user.image">
                                    <b-form-group label="Загруженная фотография">
                                        <img :src="user.image" alt="">
                                    </b-form-group>

                                    <b-form-group>
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="image_clean" value="1" v-model="images.image_clean">
                                            <label class="custom-control-label" for="image_clean">Удалить фото</label>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>

                            <h4>Подпись</h4>

                            <div class="row">
                                <div class="col col-lg-6">
                                    <b-form-group
                                        description='Подготовьте и загрузите скан подписи с соотношением сторон 2:1 (прямоугольник) размерами примерно 400x200. Допустимы файлы форматов: jpeg, png, gif. [signature_file]'
                                    >
                                        <b-form-file id="file-default" v-model='images.signature_file'
                                                     accept="image/jpeg, image/png, image/gif"
                                                     placeholder="Выберите файл..."
                                                     drop-placeholder="Кидать файло сюды..."
                                        ></b-form-file>
                                    </b-form-group>
                                </div>
                                <div class="col col-lg-6" v-if="user.signature_url">
                                    <b-form-group label="Загруженная подпись">
                                        <img :src="user.signature_url" alt="" width="100%">
                                    </b-form-group>

                                    <b-form-group >
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="signature_clean" value="1" v-model="images.signature_clean">
                                            <label class="custom-control-label" for="signature_clean">Удалить подпись</label>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>

                        </div>
                    </div>

                    <hr />

                    <div class="row">
                        <div class="col col-sm-6 col-lg-4">
                            <b-form-group label='Отправка почты'>
                                <select  class="form-control" name="mail_transport" v-model="user.mail_transport">
                                    <option value="0">Не отправлять</option>
                                    <option value="1">Настройки компании</option>
                                    <option value="5">Ядекс</option>
                                    <option value="6">Gmail</option>
                                    <!--option value="7">Mail.ru</option-->
                                </select>
                            </b-form-group>
                        </div>
                        <div class="col col-sm-6 col-lg-4">

                            <b-form-group label='Пользователь' description="E-mail, от имени которого будет отправляться почта">
                                <input type='text' class="form-control" v-model="user.mail_username">
                            </b-form-group>

                        </div>
                        <div class="col col-sm-6 col-lg-4">

                            <b-form-group label='Пароль'>
                                <input type='text'  class="form-control" v-model="user.mail_password">
                            </b-form-group>
                        </div>
                    </div>
                    <div>
                        <b-button-group>
                            <a class="btn btn-warning" :href="'http://zt.nsb.su/nsb-system-personnel/items-edit-modules/'+user.id"> <i class="fa fa-bicycle"></i> Модули (старые)</a>
                            <button class="btn btn-secondary" @click="onCancel()"> <i class="icon-logout"></i> Завершить</button>
                            <button class="btn btn-success" @click="onApply()"> <i class="fa fa-save"></i> Сохранить </button>
                            <button class="btn btn-success" @click="onSave()"> <i class="fa fa-save"></i> Сохранить и завершить</button>
                            <button class="btn btn-secondary" @click="onTestMail()" :disabled="!can_send_test"> <i class="fa fa-send"></i> Тестовое письмо</button>
                        </b-button-group>
                    </div>
                </b-card>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_company } from '@/functions/company.js';

    import {CONSTANTS} from '@/constants';
    import ButtonGroups from "../../buttons/ButtonGroups.vue";

    export default {
        components: {ButtonGroups},
        name: 'AdminUser',
        mixins: [functions, functions_loaders, functions_company],
        data: function () {
            return {
                user_id:null,
                images: {
                    image_file: null,
                    image_clean: false,
                    signature_file: null,
                    signature_clean: false,
                },
                can_send_test:false,
            }
        },
        methods: {
            comparatorMain: function() {
                return function(element) {
                    if (element.m_disabled) {
                        return false;
                    }
                    if (element.m_erase) {
                        return false;
                    }
                    if (element.main_id) {
                        return false;
                    }
                    return true;
                }
            },
            onCancel: function () {
                this.backOrRouteTo('/admin/users');
            },
            onApply: function () {
                this.saveUser(this.images, function(self){
                    self.resetUser().loadUser(self.user_id, function (self) {
                        self.reloadView();
                        console.log(self.user)
                        self.can_send_test = self.is(self.user.mail_transport) && self.is(self.user.mail_username) && self.is(self.user.mail_password);
                        console.log(self.can_send_test)
                    }, self);
                }, this);
            },
            onSave: function () {
                let self = this;
                this.saveUser(this.images, function() {
                    self.backOrRouteTo('/admin/users');
                });
            },
            onTestMail: function () {
                let self = this;
                this.testMailUser(this.user_id, function(response) {
                    alert('test send');
                    console.log(response)
                });
            },

        },
        computed: {
            mainCompanies: function() {
                return this.companies.filter(this.comparatorMain())
            },
        },
        created: function() {
            this.user_id = this.$router.currentRoute.params.user_id;
            this.loadUser(this.user_id, function (self) {
                console.log(self.user)
                self.can_send_test = self.is(self.user.mail_transport) && self.is(self.user.mail_username) && self.is(self.user.mail_password);
                console.log(self.can_send_test)
            }, this);
            this.loadRoles();
            this.loadCompanies();
        }
    }
</script>
